import ItnAPI from './_integrationApi.js';
import commonFn from '@/commons/commonFunction';
import httpClient from '@/apis/base/httpclient';

class IntegrationInvoiceBotApi extends ItnAPI {
  constructor() {
    super();
  }
  controllerName = 'Inbots';

  /**
   * API gọi OTP khi xác thực qua SMS, Email
   * @param {} model 
   * @returns 
   */
  authenOTPV2(model){
    let reuqest = {
      url: this.getAPIUrl() + '/AuthenOTPV2',
      data: model,
    }
    return this.postAsync(reuqest);
  }

  /**
   * API gọi phương thức xác thực khác
   * @param {*} model 
   * @returns 
   */
  anotherWayAuthen(model) {
    let request = {
      url: this.getAPIUrl() + '/AnotherWayAuthen',
      data: model,
    };
    return this.postAsync(request);
  }

  /**
   * API Xử lý xác thực hai lớp
   * @param {*} model 
   * @returns 
   * HMDUC2 24/07/2024
   */
  twoFactorAuthen(model) {
    let request = {
      url: this.getAPIUrl() + '/TwoFactorAuthen',
      data: model,
    };
    return this.postAsync(request);
  }

  /**
   * Thực hiện check kết nối
   * tvhien 17.10.2023
   */
  checkConnect() {
    let request = {
      url: this.getAPIUrl() + '/CheckConnect',
    };

    return this.getAsync(request);
  }

  /**
   * Thực hiện kết nỗi invoiceBot
   * @param {*} loginModel
   * @returns
   * tvhien 17.10.2023
   */
  connectMeInvoice(loginModel) {
    let request = {
      url: this.getAPIUrl() + '/connect',
      data: loginModel,
    };
    return this.postAsync(request);
  }

  /**
   * thực hiện hủy kết nối
   * @param {*} loginModel
   * @returns
   * tvhien 17.10.2023
   */
  disconnect() {
    let request = {
      url: this.getAPIUrl() + '/Disconnect',
      data: {},
    };
    return this.postAsync(request);
  }

  /**
   * Thực hiện lấy danh sách hóa đơn từ invoiceBot
   * @param {*} param
   * @returns
   * tvhien 19.10.2023
   */
  getInvoiceBotData(param) {
    const url = this.getAPIUrl() + '/GetInvoiceBotData';
    const data = param;
    const request = {url, data};

    return this.postAsync(request);
  }

  /**
   * Lấy thông tin license
   * @returns
   * tvhien 23.10.2023
   */
  getLicense() {
    let request = {
      url: this.getAPIUrl() + '/license',
    };

    return this.getAsync(request);
  }

  /**
   * lấy danh sách liên kết
   * tvhien 26.10.2023
   */
  getRefTypeReference(id) {
    let request = {
      url: this.getAPIUrl() + `/reference/${id}`,
    };

    return this.getAsync(request);
  }

  /**
   * kiểm tra xem đã đồng bộ xong chưa
   * @returns
   * tvhien 01.11.2023
   */
  checkAsyncData() {
    let request = {
      url: this.getAPIUrl() + `/check`,
    };

    return this.getAsync(request);
  }

  /**
   * Lấy về trạng thái chấp nhận thỏa thuận sử dụng của đơn vị
   * tvhien 08.11.2023
   */
  getStatusAgreement() {
    const url = this.getAPIUrl() + '/GetStatusAgreement';
    const request = {url};
    return this.getAsync(request);
  }

  /**
   * Lấy về thỏa thuận sử dụng hiện tại của một đơn vị
   * tvhien 08.11.2023
   */
  getCurrentAgreement() {
    const url = this.getAPIUrl() + '/GetCurrentAgreement';
    const data = null;
    const request = {url, data};
    return this.getAsync(request);
  }

  /**
   * Cập nhật xác nhận đồng ý thỏa thuận sử dụng
   * tvhien 08.11.2023
   */
  updateAcceptAgreement() {
    let request = {
      url: this.getAPIUrl() + '/UpdateAcceptAgreement',
    };
    return this.postAsync(request);
  }
}
export default new IntegrationInvoiceBotApi();
